import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';
import svgSrc from 'assets/top50-2023.svg';

export const G2BadgeTop50 = ({
  className,
  style: styleFromProps,
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <figure style={style} className={classNames(className)} onClick={onClick}>
      <img src={svgSrc} alt="Top 50" />
    </figure>
  );
};
